<div class="dialog-form bill-claim-form">
  <header mat-dialog-title class="dialog-form__title">
    <h2 *ngIf="!isRebill">Bill Visit</h2>
    <h2 *ngIf="isRebill">Rebill Visit</h2>
  </header>
  <main mat-dialog-content>
    <div class="dialog-form__container">
      <ng-container *ngIf="formInitialized">
        <lib-form-group [formGroup]="formGroup" hideTitle="true">
          <lib-form-field
            [parent]="formGroup"
            placeholder="Claim Type"
            name="claimType"
            focusId="claimType"
            type="select"
            [options]="claimTypes"
            (selectionChanged)="typeChanged($event)"
            class="form-span-6"
          ></lib-form-field>
          <lib-form-field *ngIf="this.selectedType !== 'Print On-Demand'" type="label" class="form-span-6" />
          <lib-form-field
            *ngIf="this.selectedType === 'Print On-Demand'"
            [parent]="formGroup"
            label="Mark as Billed"
            name="isHistory"
            type="checkbox"
            focusId="isHistory"
            class="form-span-3 checkbox"
          >
          </lib-form-field>
          <lib-form-field
            *ngIf="this.selectedType === 'Print On-Demand'"
            [parent]="formGroup"
            label="Include Background"
            name="printImage"
            type="checkbox"
            focusId="printImage"
            class="form-span-3 checkbox"
          >
          </lib-form-field>
          <lib-form-field
            [parent]="formGroup"
            label="Insurance"
            (selectionChanged)="insuranceSelectionChange($event)"
            name="insurance"
            type="select"
            [array]="insuranceArray"
            class="form-span-6"
          ></lib-form-field>
          <lib-form-field
            *ngIf="this.selectedInsuranceType !== 'Paper' && this.selectedInsuranceType !== 'Electronic'"
            [parent]="formGroup"
            placeholder="Frequency Code"
            name="frequencyCodeId"
            focusId="frequencyCodeId"
            type="autocomplete"
            [apiService]="frequencyCodeService"
            class="form-span-6"
            label="Frequency Code"
          ></lib-form-field>
          <lib-form-field
            [parent]="formGroup"
            label="Corrected Claim"
            name="isCorrected"
            type="checkbox"
            focusId="isCorrected"
            (checkedChanged)="claimCheckboxChanged($event)"
            *ngIf="this.selectedInsuranceType === 'Paper' || this.selectedInsuranceType === 'Electronic'"
            class="form-span-3 checkbox"
          >
          </lib-form-field>
          <lib-form-field
            [parent]="formGroup"
            label="Void Claim"
            name="isVoided"
            focusId="isVoided"
            type="checkbox"
            (checkedChanged)="claimCheckboxChanged($event)"
            *ngIf="this.selectedInsuranceType === 'Paper' || this.selectedInsuranceType === 'Electronic'"
            class="form-span-3 checkbox"
          >
          </lib-form-field>
          <lib-form-field
            [parent]="formGroup"
            placeholder="ICN"
            name="originalICN"
            focusId="originalICNText"
            label="ICN"
            type="autocomplete"
            [options]="insuranceICNList"
            (autoCompleteFilterChanged)="icnFilterChanged($event)"
            class="form-span-6"
          ></lib-form-field>
          <lib-form-field
            [parent]="formGroup"
            placeholder="Delay Reason Code"
            name="delayReasonCode"
            focusId="delayReasonCode"
            type="autocomplete"
            [options]="delayReasonCodes"
            class="form-span-6"
            label="Delay Reason Code"
          ></lib-form-field>
        </lib-form-group>
      </ng-container>
    </div>
  </main>
  <div mat-dialog-actions class="actions">
    <button class="button" mat-stroked-button mat-dialog-close>Cancel</button>
    <lib-button-loading
      *ngIf="formInitialized"
      color="primary"
      class="button"
      [loading]="saving"
      [invalid]="!visit || formGroup.invalid || invalidState"
      (clickEvent)="save()"
      >{{ saveText }}
    </lib-button-loading>
  </div>
</div>
